import React from 'react'
import { Link } from 'react-router-dom'

const CartItem = ({title,img,decrement,value,increment}) =>(
  <div className="cartItem">
    <div>
      <h4>{title}</h4>
      <img src={img} alt="cart-item" />
    </div>
    <div className='cartbuttons'>
      <button onClick={decrement}>-</button>
      <input type="number" readOnly value={value} />
      <button onClick={increment}>+</button>
    </div>
  </div>
)


const Cart = () => {
  const increment = () =>{

  }
  const decrement = () =>{

  }
  return <section className='cart'>
    <main className='cart-main'>
      <CartItem
      title={"Ras malai"}
      img={"/rasmalaicatout.png"}
      value={0}
      increment={increment}
      decrement={decrement}
      />
      <CartItem
      title={"Mishti doi"}
      img={"/mishti-doi-catout.png"}
      value={0}
      increment={increment}
      decrement={decrement}
      />
      <CartItem
      title={"Roshgolla"}
      img={"/rosogolla-catout.png"}
      value={0}
      increment={increment}
      decrement={decrement}
      />
      <article>
        <div>
          <h4>Sub Total</h4>
          <p>৳{3000}</p>
        </div>
        <div>
          <h4>Tax</h4>
          <p>৳{3000*0.18}</p>
        </div>
        <div>
          <h4>Shipping Charges</h4>
          <p>৳{100}</p>
        </div>
        <div>
          <h4>Total</h4>
          <p>৳{3000 + 3000*0.18 + 200}</p>
        </div>
        <Link to="/shipping">Checkout</Link>
      </article>
    </main>
  </section>
}

export default Cart